const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  date: 'l=>l.Date',
  deviceName: 'l=>l.Device.Name',
  ticketCode: 'l=>l.TicketCode',
  bookingId: 'l=>l.BookingId',
}

export const mapSortLogParam = (key: string) => mapping[key]
